import React from 'react';
import {Link} from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">404</h1>
        <p className="text-gray-500 mb-4">Page not found</p>
        <Link to="/" className="text-indigo-600 hover:text-indigo-800 font-medium">Go Home</Link>
      </div>
    </div>
  );
}
